import { render } from "./PlanOrderImportSettings.vue?vue&type=template&id=70a270c8&scoped=true&ts=true"
import script from "./PlanOrderImportSettings.vue?vue&type=script&lang=ts"
export * from "./PlanOrderImportSettings.vue?vue&type=script&lang=ts"

import "./PlanOrderImportSettings.vue?vue&type=style&index=0&id=70a270c8&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a270c8"]])

export default __exports__